export type BetslipAnimationOrigin = {
  x: number;
  y: number;
};

export const BETSLIP_OUTCOME_ANIMATION_ORIGIN_EVENT = 'betslipOutcomeAnimationOrigin';

let lastBetslipAnimationOrigin: BetslipAnimationOrigin | null = null;

export const publishBetslipAnimationOrigin = (element: HTMLElement) => {
  const rect = element.getBoundingClientRect();
  const origin = {
    x: rect.left + rect.width / 2,
    y: rect.top + rect.height / 2,
  };

  lastBetslipAnimationOrigin = origin;
  window.dispatchEvent(new CustomEvent(BETSLIP_OUTCOME_ANIMATION_ORIGIN_EVENT, { detail: origin }));
};

export const consumeBetslipAnimationOrigin = () => {
  const origin = lastBetslipAnimationOrigin;

  // Clear after read so a later bet count change cannot replay an old origin.
  lastBetslipAnimationOrigin = null;

  return origin;
};
